import type { RowActionButtonBaseProps } from '@openx/types/tableHelpers.ts';
import { trackCreateDealConversion } from '@openx/utils/lib/googleAnalytics.ts';
import { useMemo } from 'react';
import { useDealActivationModal } from '../../../components/DealActivationModal/useDealActivationModal.tsx';
import type { DealLibraryItem } from '../../../types/index.ts';

export function useDealLibraryRowActions(): Record<string, RowActionButtonBaseProps<DealLibraryItem> | undefined> {
  const { openDealActivationModal } = useDealActivationModal();

  const dealLibraryRowActions = useMemo(
    () => ({
      CREATE_DEAL: {
        'data-test': 'create-deal-button',
        label: 'Create Deal',
        onClick: (deal: DealLibraryItem) => {
          trackCreateDealConversion();
          openDealActivationModal(deal.name);
        },
      },
    }),
    [openDealActivationModal]
  );

  return dealLibraryRowActions;
}
